export default __webpack_public_path__ + "static/transformImg3-45fed90e11c52e7f43ba19a2cae9394d.png";